import React from 'react';
import prothomei_logo from '../assets/img/client_logo/prothomei.png';
import duaredoctor_logo from '../assets/img/client_logo/duaredoctor.png';

const OurClient = () => {

    const items = [
        {title: 'Prothomei', link: 'https://prothomei.com', image: prothomei_logo},
        {title: 'Duare Doctor', link: 'https://duaredoctor.com', image: duaredoctor_logo},
        {title: 'Duare Doctor (android)', link: 'https://play.google.com/store/apps/details?id=com.duaredoctorltd', image: duaredoctor_logo},
    ]

    return (
        <section className="my-5 py-10 px-2 sm:px-4 md:px-8 lg:px-12 xl:px-14">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-center gap-4 lg:gap-6">
                {items.map((item,index) => (
                    <a key={index} href={item.link} target="_blank" rel="noreferrer" className="bg-white shadow-md hover:shadow-lg animate__animated animate__zoomInUp">
                        <div className="p-2 sm:p-4 md:p-6 lg:p-8">
                            <img src={item.image} alt={item.title} className="mx-auto max-h-24 transition duration-1000 hover:scale-110" />
                        </div>
                        <h2 className="text-center px-2 py-4 text-slate-900 font-bold text-lg md:text-xl">{item.title}</h2>
                    </a>
                ))}
            </div>
        </section>
    )
}

export default OurClient